exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ContentWrapper__contentWrapper___16hI9 {\n  padding: 0;\n  margin: 0;\n  opacity: 0;\n  visibility: hidden; }\n\n.ContentWrapper__contentWrapperPadding___3SipB {\n  padding: 20px 40px; }\n\n.ContentWrapper__contentWrapper___16hI9.ContentWrapper__show___7b3e3 {\n  opacity: 1;\n  visibility: visible; }\n", ""]);

// exports
exports.locals = {
	"contentWrapper": "ContentWrapper__contentWrapper___16hI9",
	"contentWrapperPadding": "ContentWrapper__contentWrapperPadding___3SipB",
	"show": "ContentWrapper__show___7b3e3"
};